import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Index from '@/views/index.vue';
import Update from '@/views/update.vue';
import Agreement from '@/views/agreement.vue';
import Success from '@/views/success.vue';
import Invoice from '@/views/invoice.vue';
import Jump from '@/views/jump.vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
    {
        path: '/',
        name: 'home',
        component: Index,
        meta: {
            adPosId: 3,
        },
    },
    {
        path: '/update',
        name: 'update',
        component: Update,
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: Agreement,
    },
    {
        path: '/custom-pay',
        name: 'custom',
        component: () => import('@/views/custom-pay.vue'),
    },
    {
        path: '/pay',
        name: 'pay',
        component: () => import('@/views/pay.vue'),
        meta: {
            adPosId: 4,
        },
    },
    {
        path: '/success',
        name: 'success',
        component: Success,
        meta: {
            adPosId: 5,
        },
    },
    {
        path: '/invoice',
        name: 'invoice',
        component: Invoice,
    },
    {
        path: '/jump',
        name: 'jump',
        component: Jump,
    },
    {
        path: '/temp-pay',
        name: 'temp',
        component: () => import('@/views/temp-pay.vue'),
    },
    {
        path: '/wechat-credit-pay',
        name: 'wechatCreditPay',
        component: () => import('@/views/wechat-credit-pay.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
});

export default router;
